/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerAccountsResponse as ModelsCustomerCustomerAccountsResponse } from '../../models/Models/Customer/customer-accounts-response';

export interface V4CustomersMeAccountsAccountNumberGet$Xml$Params {
  accountNumber: string;
}

export function v4CustomersMeAccountsAccountNumberGet$Xml(http: HttpClient, rootUrl: string, params: V4CustomersMeAccountsAccountNumberGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerAccountsResponse>> {
  const rb = new RequestBuilder(rootUrl, v4CustomersMeAccountsAccountNumberGet$Xml.PATH, 'get');
  if (params) {
    rb.path('accountNumber', params.accountNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerCustomerAccountsResponse>;
    })
  );
}

v4CustomersMeAccountsAccountNumberGet$Xml.PATH = '/v4/customers/me/accounts/{accountNumber}';
